import { render, staticRenderFns } from "./SearchBranch.vue?vue&type=template&id=4d48bcc8&scoped=true&lang=pug"
import script from "./SearchBranch.vue?vue&type=script&lang=ts"
export * from "./SearchBranch.vue?vue&type=script&lang=ts"
import style0 from "./SearchBranch.vue?vue&type=style&index=0&id=4d48bcc8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d48bcc8",
  null
  
)

export default component.exports